<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.ibgw.org">© Safe Core Systems 2020</a>
          </li>
          <li>
            <md-button class="md-small md-info" href="tel:7082311111">Call Now | 708-231-1111</md-button>
          </li>
          <li>
            <a href="https://safecoresystems.com/info/">SAFECORE.COM</a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
